export enum VerificationType {
    Temp,
    LP,
    PO
}